import React from "react";

const BrandLogo: React.FC = () => {
  return (
    <div className="w-[15rem] ml-5">
      <a href="/">
        <img width={200} src={"/logo-bpi.svg"} />
      </a>
    </div>
  );
};

export default BrandLogo;
